const createModuleRoutes = (base, subRoutes = {}) => {
    const routes = { BASE: base };
    for (const [key, path] of Object.entries(subRoutes)) {
        routes[key] = `${base}${path}`;
    }
    return routes;
};

export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    FORGET_PASSWORD: '/forget_password',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/change_password',
    SET_PASSWORD: '/set_password',
    PASSWORD_SUCCESS: '/password-success',
    FORGET_PASSWORD_SENT: '/forget-password/sent',

    PROFILE: '/profile',
    MEMBER: '/members',

    CAR: '/cars',
    CHARGING_BILL: '/charging-bill',

    CONTRACT: createModuleRoutes('/contracts', {
        DETAIL: '/:id'
    }),

    ELECTRIC: createModuleRoutes('/electric', {
        BILLING: '/billing',
        TEST: '/test',
        USAGE: '/usage',
        EMAIL_SETTING: '/email-setting'
    }),

    REGISTER_CARD: '/register-card',
    REGISTER_CARD_SUCCESS: '/register-card-success',
    REGISTER_CARD_FAILURE: '/register-card-failure',
    CREDIT_CARD: '/credit-cards',

    TODAY_PRICE: '/today-price',
    EDIT_INFO: '/edit-info',
    EDIT_EMAIL: '/edit-email',
    EDIT_PHONE: '/edit-phone',
};

const flattenRoutes = (routesObj) => {
    const values = [];
    for (const value of Object.values(routesObj)) {
        if (typeof value === 'string') {
            values.push(value);
        } else if (typeof value === 'object') {
            values.push(...flattenRoutes(value));
        }
    }
    return values;
};

export const paths = flattenRoutes(ROUTES);

export const publicRoutes = [
    ROUTES.LOGIN,
    ROUTES.FORGET_PASSWORD,
    ROUTES.RESET_PASSWORD,
    ROUTES.CHANGE_PASSWORD,
    ROUTES.SET_PASSWORD,
    ROUTES.PASSWORD_SUCCESS,
    ROUTES.TODAY_PRICE,
    ROUTES.FORGET_PASSWORD_SENT,
    ROUTES.REGISTER_CARD_SUCCESS,
    ROUTES.REGISTER_CARD_FAILURE,
    ROUTES.ELECTRIC.TEST
];
